import _ from 'lodash';

export default class Utils {
  static getParam(key: string) {
    return this.getParams()[key];
  }

  static getParams() {
    type Params = {
      [key: string]: string;
    };
    const result: Params = {};

    if (!window.location) {
      return result;
    }
    if (_.isEmpty(window.location.search)) {
      return result;
    }
    const query = window.location.search.substring(1);
    const params = query.split('&');
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < params.length; i += 1) {
      const param = params[i];
      const kv = param.split('=');
      const key = kv[0];
      const val = decodeURIComponent((kv[1] || '').replace(/\+/g, ' '));
      result[key] = val;
    }
    return result;
  }

  static mpIdentify(distinctId: string): void {
    if (typeof mixpanel === 'undefined') {
      // wait for mixpanel loading
      setTimeout(() => {
        this.mpIdentify(distinctId);
      }, 100);
    } else {
      mixpanel.identify(distinctId);
    }
  }

  static trackEvent(name: string, properties = {}): void {
    if (typeof mixpanel === 'undefined') {
      // wait for mixpanel loading
      setTimeout(() => {
        this.trackEvent(name, properties);
      }, 100);
    } else {
      mixpanel.track(name, properties);
    }
  }

  static dig(object: any, ...keys: any[]) {
    let obj = object;
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < keys.length; i += 1) {
      const key = keys[i];
      if (obj) {
        if (typeof obj[key] === 'function') {
          obj = obj[key]();
        } else {
          obj = obj[key];
        }
      } else {
        return null;
      }
    }
    return obj;
  }

  static copyToClipboard(showAlert = true) {
    document.execCommand('copy');
    if (showAlert) {
      // eslint-disable-next-line no-alert
      alert('クリップボードにコピーしました');
    }
  }

  static selectRange(el: HTMLElement): any {
    const range = document.createRange();
    const sel = window.getSelection();
    if (sel) {
      sel.removeAllRanges();
      try {
        range.selectNodeContents(el);
        sel.addRange(range);
      } catch (e) {
        range.selectNode(el);
        sel.addRange(range);
      }
    }
    return sel;
  }

  // 元のcoffeescript
  //
  // copyElementToClipBoard: (el, showAlert = true) ->
  //   if document.createRange && window.getSelection
  //     selectRange(el)
  //     copyToClipboard(showAlert)
  //   else if body.createTextRange
  //     range = body.createTextRange()
  //     range.moveToElementText(el)
  //     range.select()
  //     copyToClipboard(showAlert)
  static copyElementToClipBoard(el: HTMLElement | null, showAlert = true) {
    if (!el) {
      return;
    }
    this.selectRange(el);
    this.copyToClipboard(showAlert);
  }

  // 元のcoffeescript
  //
  // # HTML貼り付け対応の是非でコピーの内容を変えられる
  // copyHTMLAndTextToClipBoard: (html, text, showAlert = true) ->
  //   if document.createRange && window.getSelection
  //     document.addEventListener "copy", listener = (event) ->
  //       event.preventDefault()
  //       event.clipboardData.setData("text/plain", selectRange(text).focusNode.innerText)
  //       event.clipboardData.setData("text/html", selectRange(html).focusNode.innerHTML)
  //       document.removeEventListener("copy", listener)
  //     copyToClipboard(showAlert)
  //   else if body.createTextRange
  //     range = body.createTextRange()
  //     range.moveToElementText(html)
  //     range.select()
  //     copyToClipboard(showAlert)
  static copyHTMLAndTextToClipBoard(html: HTMLElement | null, text: HTMLElement | null, showAlert = true) {
    const listener = (event: ClipboardEvent) => {
      event.preventDefault();
      if (event.clipboardData) {
        if (text) {
          event.clipboardData.setData('text/plain', this.selectRange(text).focusNode.innerText);
        }
        if (html) {
          event.clipboardData.setData('text/html', this.selectRange(html).focusNode.innerHTML);
        }
      }
      document.removeEventListener('copy', listener);
    };
    document.addEventListener('copy', listener);
    this.copyToClipboard(showAlert);
  }
}
